var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategoryBuilderIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 12.92,
    viewBox: "0 0 19 12.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Category_Builder_Icon",
    transform: "translate(-460 -716)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3190",
    "data-name": "Group 3190",
    transform: "translate(460 716)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_636",
    "data-name": "Rectangle 636",
    width: 19,
    height: 5.89,
    rx: 2.945,
    transform: "translate(0)",
    fill: "#243746"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5553",
    "data-name": "Group 5553",
    transform: "translate(460 723.03)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_815",
    "data-name": "Rectangle 815",
    width: 10.07,
    height: 5.89,
    rx: 2.945,
    fill: "#243746"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_816",
    "data-name": "Rectangle 816",
    width: 7.22,
    height: 5.89,
    rx: 2.945,
    transform: "translate(471.78 723.03)",
    fill: "#243746"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryBuilderIcon);
export default __webpack_public_path__ + "static/media/Category_Builder_Icon.3dee607a.svg";
export { ForwardRef as ReactComponent };